<section class="product-images-component">
  <div class="product-images-header">
    <div class="title">
        {{ 'text_productImages' | dbText }}
    </div>
    <div class="description">
        {{ 'text_productImagesDescription' | dbText }}
    </div>
  </div>
  <div class="product-images-body">
    <div class="row">
      <div class="product-images-row">
        <div class="product-images-row-header">
          <div class="title">
              {{ 'text_mainProductImage' | dbText }}
          </div>
        </div>
        <div class="product-images-row-body">
          <div class="product-image empty" (click)="openMediaLib(true)" *ngIf="!mainImage; else mainImageTemp">
            <i class="db-icon db-icon-ds-bold-download"></i>
          </div>
          <ng-template #mainImageTemp>
            <div class="product-image" [class.file]="mainImage.media_type && mainImage.media_type !== 'image'">
              <ng-container *ngIf="mainImage.media_type && mainImage.media_type !== 'image';else imageItem">
                <i class="db-icon db-icon-ds-file-filled"></i>
                <div class="file-name-container">
                  <div>{{mainImage.title.rendered}}</div>
                </div>
              </ng-container>
              <ng-template #imageItem>
                <img [src]="mainImage.source_url || mainImage.src">
              </ng-template>
              <div class="actions-container">
                <div class="drag-action" (click)="openMediaLib(true)">
                  <i class="db-icon db-icon-ds-replace-image"></i>
                </div>
                <div class="delete-action" (click)="$event.stopPropagation(); removeImage(mainImage, true)">
                  <i class="db-icon db-icon-ds-remove-outline"></i>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="product-images-row">
        <div class="product-images-row-header">
          <div class="title">
              {{ 'text_productImageGallery' | dbText }}
          </div>
          <div class="action" [class.disabled]="!secondaryImages.length" (click)="deleteSelectedImages()">
            {{ 'text_deleteSelectedImages' | dbText }}
          </div>
        </div>
        <div class="product-images-row-body">
          <div class="product-image empty" (click)="openMediaLib()">
            <i class="db-icon db-icon-ds-bold-download"></i>
          </div>
          <div class="product-images-container"
               [dragulaModel]="secondaryImages"
               (dragulaModelChange)="secondaryImagesOrderChanged($event)"
               [dragula]="'PRODUCT_IMAGES'">
            <div class="product-image"
                 [class.file]="image.media_type && image.media_type !== 'image'"
                 [class.selected]="selectedImages.includes(image.id)"
                 (click)="selectImage(image)"
                 *ngFor="let image of secondaryImages">
              <ng-container *ngIf="image.media_type && image.media_type !== 'image';else imageItem">
                <i class="db-icon db-icon-ds-file-filled"></i>
                <div class="file-name-container">
                  <div>{{image.title.rendered}}</div>
                </div>
              </ng-container>
              <ng-template #imageItem>
                <img [src]="image.source_url || image.src">
              </ng-template>
              <div class="actions-container">
                <div class="drag-action image-handle">
                  <i class="db-icon db-icon-ds-drag image-handle"></i>
                </div>
                <div class="delete-action" (click)="$event.stopPropagation(); removeImage(image)">
                  <i class="db-icon db-icon-ds-remove-outline"></i>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
